module.exports = __webpack_public_path__ + "media/images/product_lines/car/h2-0a9a4a27be845b404ace3cd1f4354917.svg";